var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarnestroiScBlockchainEtherium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.422,
    height: 60.829,
    viewBox: "0 0 40.422 60.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-77.579 65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1421394342400",
    transform: "translate(77.579 -65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20720",
    "data-name": "Group 20720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_31639",
    "data-name": "Path 31639",
    transform: "translate(3.551)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.658,0l-.446,1.368v39.7l.446.4L36.833,29.536Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.25209045410156 5.950199127197266 L 18.25209045410156 38.1556510925293 L 33.92032241821289 28.88883972167969 L 18.25209045410156 5.950199127197266 M 16.65827941894531 0 L 36.8330078125 29.53625106811523 L 16.65827941894531 41.4683837890625 L 16.21208953857422 41.06652069091797 L 16.21208953857422 1.368190765380859 L 16.65827941894531 0 Z",
    stroke: "none",
    fill: "#0e8ece"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_31640",
    "data-name": "Path 31640",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.205,0,0,29.574,20.205,41.468V0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.16511917114258 6.60223388671875 L 2.915412902832031 28.92321968078613 L 18.16511917114258 37.90027618408203 L 18.16511917114258 6.60223388671875 M 20.20512008666992 0 L 20.20512008666992 41.4683837890625 L 0 29.57422256469727 L 20.20512008666992 0 Z",
    stroke: "none",
    fill: "#0e8ece"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_31641",
    "data-name": "Path 31641",
    transform: "translate(3.586 1.713)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.619,42.581l-.249.3V58.39l.249.727L36.836,30.644Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.63141059875488 37.26700973510742 L 18.41019439697266 43.89247894287109 L 18.41019439697266 53.07025527954102 L 29.63141059875488 37.26700973510742 M 36.83607482910156 30.64402008056641 L 16.61911392211914 59.11630249023438 L 16.37019348144531 58.38966369628906 L 16.37019348144531 42.88449096679688 L 16.61911392211914 42.58095169067383 L 36.83607482910156 30.64402008056641 Z",
    stroke: "none",
    fill: "#012043"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_31642",
    "data-name": "Path 31642",
    transform: "translate(0 1.713)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.205,59.116V42.581L0,30.644Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.16511917114258 52.71664428710938 L 18.16511917114258 43.74515533447266 L 7.20254373550415 37.26860427856445 L 18.16511917114258 52.71664428710938 M 20.20512008666992 59.11630249023438 L 4.333496050890062e-08 30.64402198791504 L 20.20512008666992 42.58095169067383 L 20.20512008666992 59.11630249023438 Z",
    stroke: "none",
    fill: "#012043"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_31643",
    "data-name": "Path 31643",
    transform: "translate(3.631 0.374)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.574,41.094l20.2-11.943-20.2-9.184Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.61438179016113 37.51874160766602 L 32.36968231201172 29.38786888122559 L 18.61438179016113 23.13542556762695 L 18.61438179016113 37.51874160766602 M 16.57438087463379 41.09435653686523 L 16.57438087463379 19.96728706359863 L 36.77898025512695 29.15124702453613 L 16.57438087463379 41.09435653686523 Z",
    stroke: "none",
    fill: "#012043"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_31644",
    "data-name": "Path 31644",
    transform: "translate(0 0.374)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,29.151,20.205,41.094V19.967Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.16532135009766 23.1353874206543 L 4.409420013427734 29.38787651062012 L 18.16532135009766 37.51881408691406 L 18.16532135009766 23.1353874206543 M 20.20532035827637 19.9672966003418 L 20.20532035827637 41.09435653686523 L 1.9073486328125e-06 29.15124702453613 L 20.20532035827637 19.9672966003418 Z",
    stroke: "none",
    fill: "#012043"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnestroiScBlockchainEtherium);
export default __webpack_public_path__ + "static/media/earnestroi-sc-blockchain-etherium.47190b6df1dd39e9ea94d91da9282a00.svg";
export { ForwardRef as ReactComponent };